export default "__VITE_PUBLIC_ASSET__decf1771__"